import styled from '@emotion/styled';

interface TabButtonProps {
	isActive?: boolean; // isActive를 선택적 prop으로 정의
}
export const MainWrapper = styled.main`
	padding-top: 0px;
	position: relative;
	.container {
		width: 100%;
		position: relative;
		overflow: hidden;
	}
`;
/** 헤더 Nav(max-width: 184rem, padding 0 2rem)와 히어로 정렬 통일 */
const heroContentMax = '184rem';

export const MainBanner = styled.article`
	padding: 0;
	min-height: 34rem;
	height: clamp(38rem, 30vw, 46rem);
	color: #fff;
	position: relative;
	isolation: isolate;
	@media screen and (max-width: 1200px) {
		height: 44rem;
	}
	@media screen and (max-width: 900px) {
		min-height: 34rem;
		height: 38rem;
	}
	@media screen and (max-width: 600px) {
		min-height: 34rem;
		height: 34rem;
	}
	@media screen and (max-width: 420px) {
		min-height: 38rem;
		height: 38rem;
	}
	.hero-image-swiper.swiper {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
		z-index: 0;
	}
	.swiper {
		width: 100%;
		height: 100%;
	}
	.swiper-slide {
		width: 100% !important;
		height: 100% !important;
		position: relative;
	}
	.swiper-fade .swiper-slide {
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
	}
	.img_container {
		position: relative;
		width: 100%;
		height: 100%;
		min-height: inherit;
		overflow: hidden;
		&.first {
			background: linear-gradient(89.69deg, #3d92c0 19.48%, rgba(61, 146, 192, 0.3) 84.47%);
		}
	}
	.background {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
		/* 가로·세로 비율과 관계없이 이미지 중앙이 보이도록 */
		object-position: center center;
	}
	.overlay {
		position: absolute;
		inset: 0;
		background: linear-gradient(89.69deg, #3d92c0 19.48%, rgba(61, 146, 192, 0.3) 84.47%);
		pointer-events: none;
	}
	.textBoxWrapper {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		left: 0;
		right: 0;
		width: 100%;
		z-index: 2;
		pointer-events: none;
		.textBox {
			pointer-events: auto;
		}
	}
	.textBox {
		display: flex;
		flex-direction: column;
		gap: 2rem;
		max-width: ${heroContentMax};
		width: 100%;
		margin: 0 auto;
		padding: 0 2rem;
		box-sizing: border-box;
		@media screen and (max-width: 600px) {
			gap: 1.6rem;
		}
		.title {
			color: #fff;
			font-size: 6.4rem;
			font-weight: ${(props) => props.theme.fontWeight.weightBold};
			line-height: 110%;
			letter-spacing: -0.6px;
			align-self: stretch;
			@media screen and (max-width: 900px) {
				font-size: 3.4rem;
			}
			@media screen and (max-width: 600px) {
				font-size: 3rem;
				line-height: 116%;
				letter-spacing: 0;
			}
			@media screen and (max-width: 360px) {
				font-size: 2.8rem;
			}
		}
		.description {
			font-size: 18px;
			font-weight: ${(props) => props.theme.fontWeight.weightRegular};
			line-height: 140%;
			letter-spacing: -0.6px;
			@media screen and (max-width: 900px) {
				font-size: ${(props) => props.theme.fontSize.sizeMd};
			}
			@media screen and (max-width: 600px) {
				font-size: 1.5rem;
				line-height: 145%;
				letter-spacing: 0;
			}
		}
	}
	.swiper-button-next,
	.swiper-button-prev {
		display: none;
	}
`;
export const Description = styled.section`
	padding: 8rem 0;
	margin: 0 auto;
	max-width: 135rem;
	width: 100%;
	background-color: ${(props) => props.theme.colors.surfacePage};
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
	@media screen and (max-width: 1370px) {
		padding: 8rem 2rem;
	}
	.main_description_title {
		color: ${(props) => props.theme.colors.textPrimary};
		text-align: center;
		display: flex;
		flex-direction: column;
		gap: 1.6rem;
		@media screen and (max-width: 900px) {
			text-align: left;
		}
		.description_title {
			font-size: ${(props) => props.theme.fontSize.size6xl};
			font-weight: ${(props) => props.theme.fontWeight.weightSemi};
			line-height: 1.25;
			letter-spacing: -0.035em;
			@media screen and (max-width: 900px) {
				font-size: ${(props) => props.theme.fontSize.size4xl};
			}
		}
		.description_sub_title {
			font-size: ${(props) => props.theme.fontSize.sizeXl};
			font-weight: ${(props) => props.theme.fontWeight.weightRegular};
			line-height: 1.45;
			letter-spacing: -0.025em;
			color: ${(props) => props.theme.colors.textSecondary};
			@media screen and (max-width: 660px) {
				br {
					display: none;
				}
			}
		}
	}
`;
export const CardList = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	@media screen and (max-width: 1100px) {
		grid-template-columns: repeat(2, 1fr);
	}
	@media screen and (max-width: 420px) {
		grid-template-columns: repeat(1, 1fr);
	}
`;
export const CardWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	order: 2;
`;
export const CardTitle = styled.div`
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	letter-spacing: -0.6px;
	display: flex;
	align-items: center;
`;
export const ImgBox = styled.div`
	display: flex;
	max-width: 8rem;
	img {
		width: 100%;
	}
`;
export const ImgBoxWrapper = styled.div`
	@media screen and (max-width: 900px) {
		display: flex;
		justify-content: flex-start;
	}
`;
export const CardSubTitle = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
`;
export const Notice = styled.section`
	padding: 8rem 0;
	background-color: #f1f3f5;
	@media screen and (max-width: 1370px) {
		padding: 8rem 2rem;
	}
	@media screen and (max-width: 900px) {
		padding: 6rem 2rem;
	}
	.content {
		padding: 2rem;
		font-size: ${(props) => props.theme.fontSize.sizeLg};
	}
`;
export const NoticeList = styled.ul`
	display: flex;
	flex-direction: column;
	padding: 2rem 3.2rem;
	.last {
		border-bottom: none;
	}
`;
export const NoticeEmptyBox = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	min-height: 41rem;
`;
export const NoData = styled.p`
	width: 100%;
	height: 100%;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	text-align: center;
`;
export const NoticeListItem = styled.li`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	padding: 1.2rem 0;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	letter-spacing: -0.6px;
	line-height: 100%;
	border-bottom: 1px solid #e9ecef;
	cursor: pointer;
	.title {
		color: #212529;
	}
	.sub_title {
		color: #868e96;
	}
`;
export const Divider = styled.div`
	width: 1px;
	height: 29px;
	background-color: #dee2e6;
	margin: 0 1.6rem;
`;
export const EmptyEl = styled.div``;
export const NoticeContent = styled.div`
	margin: 0 auto;
	max-width: 135rem;
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;
export const NoticeContentList = styled.div`
	display: flex;
	gap: 3.2rem;
	justify-content: space-between;
	width: 100%;
	@media screen and (max-width: 900px) {
		flex-direction: column;
	}
`;
export const CardImg = styled.div<{ bgImg: string }>`
	background-image: linear-gradient(0deg, rgba(0, 21, 52, 0.6) 0%, rgba(0, 21, 52, 0.6) 100%), url(${(props) => props.bgImg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	background-clip: content-box;
	background-origin: content-box;
	position: relative;
	display: flex;
	border-radius: 1.6rem;
	flex: 1;
	min-height: 41rem;
	max-height: 45rem;
	width: 100%;
	cursor: pointer;
	box-shadow:
		0px 0px 4px 0px rgba(0, 0, 0, 0.06),
		4px 8px 8px 0px rgba(0, 0, 0, 0.02),
		12px 8px 24px 0px rgba(0, 0, 0, 0.1);
	.title_box {
		display: flex;
		flex-direction: column;
		gap: 1.2rem;
		position: absolute;
		top: 50%;
		left: 3rem;
		transform: translateY(-50%);
		@media screen and (max-width: 900px) {
			right: 3rem;
		}
		.title {
			color: #fff;
			font-size: 4rem;
			font-weight: 700;
			line-height: 120%;
			letter-spacing: -0.6px;
			@media screen and (max-width: 900px) {
				font-size: 3.2rem;
			}
		}
		.sub_title {
			color: #fff;
			font-size: 1.8rem;
			font-weight: 400;
			line-height: 120%;
			letter-spacing: -0.6px;
		}
	}
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 1.6rem;
	}
`;
export const NoticeButtonTab = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;
export const ButtonList = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;
export const TabButton = styled.div<TabButtonProps>`
	font-size: ${(props) => props.theme.fontSize.size4xl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	background: none;
	color: ${(props) => (props.isActive ? '#212529' : '#adb5bd')};
	border: none;
	cursor: pointer;
	@media screen and (max-width: 900px) {
		font-weight: ${(props) => props.theme.fontWeight.weightBold};
	}
`;
export const NoticeTabList = styled.div`
	display: flex;
	gap: 3.2rem;
`;
export const Wrapper = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-between;
	@media screen and (max-width: 900px) {
		width: 100%;
		gap: 2.4rem;
		flex-direction: column;
	}
`;
export const GotoButton = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 0.8rem;
	border: none;
	background: none;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	color: #495057;
	cursor: pointer;
	@media screen and (max-width: 900px) {
		justify-content: flex-end;
	}
`;
export const Company = styled.div`
	padding: 8rem 0;
	max-width: 136rem;
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
	@media screen and (max-width: 1370px) {
		padding-left: 2rem;
	}
	.title {
		font-size: ${(props) => props.theme.fontSize.size4xl};
		font-weight: ${(props) => props.theme.fontWeight.weightSemi};
		line-height: 130%;
		letter-spacing: -0.6px;
		color: #212529;
	}
`;
export const CompanyFixedRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 1.6rem;
	justify-content: center;
`;
export const CompanySlider = styled.div`
	.swiper {
		--swiper-space-between: 16px;
	}
	.swiper-wrapper {
	}
	.swiper-slide {
		width: unset;
		height: 14.7rem;
		/* height: 16.2rem; */
	}
	.swiper-button-prev {
		right: 4.6rem;
		top: unset;
		bottom: 0;
		left: unset;
		color: #868e96;
		@media screen and (max-width: 900px) {
			right: 6.6rem;
		}
	}
	.swiper-button-next {
		right: 0rem;
		top: unset;
		bottom: 0;
		color: #868e96;
		@media screen and (max-width: 900px) {
			right: 2rem;
		}
	}
	.swiper-button-prev::after {
		color: var(--color-base-white);
		font-size: var(--font-s-small);
		font-weight: var(--font-w-light);
		line-height: 1.551rem;
	}
	.swiper-button-next::after {
		color: var(--color-base-white);
		font-size: var(--font-s-small);
		font-weight: var(--font-w-light);
		line-height: 1.551rem;
	}
`;
export const CompanyCard = styled.div<{ padding?: boolean; division?: 'width' | 'height' }>`
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 1.6rem;
	background-color: #f8f9fa;
	border: 1px solid #dee2e6;
	width: 21.2rem;
	height: 9.1rem;
	overflow: hidden;
	padding: ${(props) => (props.padding ? '3.2rem' : '1.2rem')};
	cursor: pointer;
	img {
		width: ${(props) => (props.division === 'width' ? 'auto' : '100%')};
		height: ${(props) => (props.division === 'width' ? '100%' : 'auto')};
		display: block;
	}
`;
